<!-- =========================================================================================
    File Name: FileUploadHistory.vue
    Description: File Upload History page
========================================================================================== -->

<template>
  <div>
    <vx-card class="overflow-auto">
      <vs-button icon-pack="feather" icon="icon-download" @click="exportExcel()">{{$t('EXPORT_EXCEL')}}</vs-button>
      <v-server-table id="file-upload-history-table" ref="fileUplaodHistoryTable" name="fileUploadHistoryTable" 
        :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" @sorted="setSortedForExcel" @filter="setFilterForExcelIncludeDateFilter">
        <!--
          <vs-chip slot="uploaderCode" slot-scope="props" :color="getUploaderCodeColor(props.row.fileRecvHistory.uploaderCode)" class="w-full" >
          {{$t(getUploaderCode(props.row.fileRecvHistory.uploaderCode))}}</vs-chip>
          -->
      </v-server-table>
    </vx-card>
  </div>
</template>

<script>
let FileSaver = require('file-saver');
import moduleUserFile from "@/store/userFile/moduleUserFile.js"

export default {
  components: {
  },
  data() {
    return {
      // Data Sidebar
      dataSidebar: false,
      sidebarData: {},
      
      // Table
      columns: ['userId', 'deviceUUID', 'fileName', 'fileSize','createdDateTime'],
      options: {
        perPage:10,
        skin: 'table',
        filterByColumn: true,
        filterable: ['userId', 'deviceUUID', 'fileName', 'fileSize','createdDateTime'],
        sortable: ['userId', 'deviceUUID', 'fileName', 'fileSize','createdDateTime'],
        debounce: 1000,
        dateColumns:['createdDateTime'],
        dateFormat: 'YYYY-MM-DD',
        toMomentFormat: 'YYYYMMDD',
        datepickerOptions: {
            showDropdowns: true,
            autoUpdateInput: true
        },
        orderBy: { ascending: false },
        sortIcon: {
          base: 'feather',
          up: 'icon-arrow-up',
          down: 'icon-arrow-down',
        },
        texts:{
          filterBy: this.$t("FILTER_BY"),
          defaultOption: this.$t("DEFAULT_OPTION"),
        },
        headings: {
          'userId' : () => this.$t("USER_ID"),
          'deviceUUID': () => this.$t("DEVICE_UUID"),
          'fileName': () => this.$t("FILE_NAME"),
          'fileSize': () => this.$t("FILE_SIZE"),
          'uploaderCode': () => this.$t("UPLOADER"),
          'createdDateTime': ()=>this.$t("UPLOAD_TIME")
        },
        listColumns:{
          uploaderCode:[
            {
              id: '1',
              text: this.$t("UPLOADER_DEVICE")
            },
            {
              id: '2',
              text: this.$t("UPLOADER_USER")
            },
          ],
        },
        requestAdapter: function(data) {

          if(data.query.createdDateTime){
            data.query = {...data.createdDateTimeAdditional, ...data.query};

            let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
            let start = moment.tz(data.query.createdDateTime.start, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            let end = moment.tz(data.query.createdDateTime.end, localTimeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            
            data.query.createdDateTimeUTC.start = start
            data.query.createdDateTimeUTC.end = end
          }

          return {
            ascending: data.ascending,
            byColumn: data.byColumn,
            pageSize: data.limit,
            orderBy: data.orderBy ? data.orderBy : "createdDateTime",
            page: data.page,
            query: data.query,
            pageResult: ((data.page-1)*data.limit)
          };
        },
        params: {
          createdDateTimeAdditional:{
            createdDateTimeUTC: {
              start: '',
              end: ''
            },
          }
        }, 
        requestFunction: function (data) {
          return this.$http.get('/api/file-recv-management/file-recv-history', {
                params: data
          }).catch(function (e) {
                this.dispatch('error', e);
                this.$vs.loading.close()
          }.bind(this));
        },
        responseAdapter: (response) => {
          this.$store.commit('dataUserFile/SET_FILE_RECV_HISTORY',response.data)
          return {
            data: this.$store.state.dataUserFile.fileRecvHistoryList,
            count: this.$store.state.dataUserFile.fileRecvHistoryCount
          }
        },
        templates:{
          userId: function(h,row){
            return row.user.userId;
          },
          deviceUUID: function(h,row){
            return row.fileRecvHistory.deviceUUID;
          },
          fileName: function(h,row){
            return row.fileRecvHistory.fileName;
          },
          fileSize: function(h,row){
            return row.fileRecvHistory.fileSize.toLocaleString() +" bytes";
          },
          createdDateTime: function(h,row){
            let createdDateTime = row.fileRecvHistory.createdDateTime
            if(!createdDateTime){
              return '-'
            }else {
              let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
              let dateTime = this.$moment(createdDateTime,'YYYYMMDDHHmmss').format()
              let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD HH:mm:ss')
          
              return dateTimeToLocal
            }
          }
        }
      }
    }
  },
  created() {
    if (!moduleUserFile.isRegistered) {
      this.$store.registerModule('dataUserFile', moduleUserFile)
      moduleUserFile.isRegistered = true
    }
  },
  mounted(){
     if (this.$route.params.userId){
        this.setFilterForExcel({
          name: "userId",
          value: this.$route.params.userId
        })
        this.$refs.fileUplaodHistoryTable.setFilter({
          userId: this.$route.params.userId
        })
     }
  },
  methods: {
    getUploaderCode(code){
      if (code === "" ) return ""
      return this.$store.state.commonConfig.uploaderCode.properties[code].name
    },
    getUploaderCodeColor(code){
      if (code === "" ) return ""
      return this.$store.state.commonConfig.uploaderCode.properties[code].color
    },
    exportExcel(){
      
      let locale = this.$i18n.locale

      this.$http({
        method: 'post',
        url: '/api/file-recv-management/file-recv-history/excel/'+locale,
        data:{
          query : JSON.stringify(this.filterForExcel),
          orderBy:  this.sortForExcel.column ? this.sortForExcel.column : 'createdDateTime' ,
          ascending: this.sortForExcel.ascending ? 1 : 0,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        withCredentials: true,
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }).then((response) => {
        let excelTitle
        if (locale === "ko") {
          excelTitle = "파일_업로드_이력.xlsx"
        } else {
          excelTitle ="File_Upload_History.xlsx"
        }
        FileSaver.saveAs(response.data, excelTitle)
      }).catch((error)=> {
        console.log(error);
      }) 
    }
  },
}

</script>

<style lang="scss" scoped>
#file-upload-history-table {
  text-align: center;
}
</style>